const INITIAL_STATE = {
  surname: '',
  forename: '',
  day: '',
  month: '',
  year: '',
  email: '',
  phoneNumber: '',
  nin: '',
  cpcsCardNumber: '',
  addressLine1: '',
  addressLine2: '',
  addressLine3: '',
  addressLine4: '',
  homePostcode: '',
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case 'GET_APPLICANT_DATA':
      return {
        ...state,
        ...payload,
      };
    case 'GET_APPLICANT_VALUES':
      return {
        ...state,
        ...payload,
      };
    case 'INITIAL_STATE':
      return {
        surname: '',
        forename: '',
        day: '',
        month: '',
        year: '',
        email: '',
        phoneNumber: '',
        nin: '',
        cpcsCardNumber: '',
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        addressLine4: '',
        homePostcode: '',
      };
    default:
  }
  return state;
};
